/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SymbolFundamentalsDataPointDto
 */
export interface SymbolFundamentalsDataPointDto {
    /**
     * 
     * @type {Date}
     * @memberof SymbolFundamentalsDataPointDto
     */
    reportDate: Date;
    /**
     * 
     * @type {number}
     * @memberof SymbolFundamentalsDataPointDto
     */
    value: number | null;
}

export function SymbolFundamentalsDataPointDtoFromJSON(json: any): SymbolFundamentalsDataPointDto {
    return SymbolFundamentalsDataPointDtoFromJSONTyped(json, false);
}

export function SymbolFundamentalsDataPointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SymbolFundamentalsDataPointDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reportDate': (new Date(json['reportDate'])),
        'value': json['value'],
    };
}

export function SymbolFundamentalsDataPointDtoToJSON(value?: SymbolFundamentalsDataPointDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reportDate': (value.reportDate.toISOString()),
        'value': value.value,
    };
}

